import { Eyebrow, SectionHeading } from "../common/Type";
import { Reveal, RevealStagger, RevealItem } from "../common/Reveal";
import Cta from "../common/Cta";
import { Link } from "react-router-dom";
import { mythorosTiers, pricingDisclosure } from "../../lib/content";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

function BlackBook() {
  return (
    <div className="mt-6 pt-6 border-t border-kv-steel/15">
      <div className="rounded-[10px] bg-kv-off text-white p-5" data-testid="black-book-addon">
        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/45">Add-on · By invitation</div>
        <div className="mt-3 flex items-baseline justify-between gap-3">
          <span className="font-display text-[15px] font-medium tracking-tight">The Black Book Package</span>
          <span className="font-body text-[13px] font-medium text-white/90 whitespace-nowrap">$9,999</span>
        </div>
        <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-white/35">One-time · Details on request</div>
        <Link
          to="/contact"
          data-testid="black-book-cta"
          className="mt-4 inline-flex items-center justify-center w-full px-5 py-2.5 text-[11px] font-medium uppercase tracking-[0.14em] border border-white/25 text-white/90 hover:bg-white hover:text-kv-off transition-colors duration-300"
        >
          Request Only
        </Link>
      </div>
    </div>
  );
}

export default function MythorosPricing() {
  return (
    <section id="pricing" className="relative py-24 md:py-32 scroll-mt-24" data-testid="mythoros-pricing">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <Eyebrow className="mb-5">Pricing</Eyebrow>
          <SectionHeading>Bundles built around how far you want to take it.</SectionHeading>
        </div>

        <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {mythorosTiers.map((t) => (
            <RevealItem key={t.name} className="h-full">
              <div className="kv-pricing-card p-7 md:p-8 flex flex-col h-full" data-testid={`pricing-tier-${slugify(t.name)}`}>
                <h3 className="font-display text-xl font-medium tracking-tight text-kv-off">{t.name}</h3>
                <p className="mt-3 font-body text-[15px] font-medium text-kv-off leading-snug">{t.price}</p>
                <div className="my-6 h-px w-full bg-kv-steel/15" />
                <ul className="space-y-2.5 flex-1">
                  {t.includes.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 font-body text-sm text-kv-grey leading-relaxed">
                      <span className="mt-[7px] h-1 w-1 rounded-full bg-kv-electric shrink-0" /> {it}
                    </li>
                  ))}
                </ul>
                <p className="mt-6 font-body text-xs text-kv-steel leading-relaxed">Best for: {t.bestFor}</p>
                <div className="mt-6">
                  <Cta to="/contact" variant="secondary" className="w-full px-5 py-2.5 text-[13px]" testId={`pricing-cta-${slugify(t.name)}`}>
                    {t.name === "Enterprise" ? "Request a quote" : "Get started"}
                  </Cta>
                </div>
                <BlackBook />
              </div>
            </RevealItem>
          ))}
        </RevealStagger>

        <Reveal>
          <p className="mt-10 max-w-4xl font-body text-xs text-kv-steel leading-relaxed" data-testid="pricing-disclosure">
            {pricingDisclosure}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
